/**
 * Default workflow and step definitions for agentic workflows.
 */

import type { AgentWorkflowDef, AgentWorkflowStep } from "@/types/agentWorkflow";

export const DEFAULT_ENABLED_TOOL_IDS = [
  "web_search",
  "file_search",
  "code_interpreter",
  "image_generation",
];

export function createBlankWorkflow(profileId: string): AgentWorkflowDef {
  const now = Date.now();
  return {
    id: `wf-${profileId}-${now}`,
    name: "Default workflow",
    steps: [
      {
        id: `step-${now}-0`,
        type: "llm",
        label: "Understand & plan",
        instruction: "Understand the user request and plan the steps needed (A, B, C, D, E or tool use).",
        order: 0,
      },
    ],
    enabledToolIds: [...DEFAULT_ENABLED_TOOL_IDS],
    maxToolRounds: 10,
    updatedAt: now,
  };
}

export function createStep(type: AgentWorkflowStep["type"], order: number): AgentWorkflowStep {
  const id = `step-${Date.now()}-${order}`;
  const labels: Record<AgentWorkflowStep["type"], string> = {
    llm: "Reason / respond",
    web_search: "Web search",
    file_search: "File search",
    code_interpreter: "Code interpreter",
    image_generation: "Image generation",
    connector: "Connector (e.g. Shopify)",
  };
  return {
    id,
    type,
    label: labels[type],
    order,
  };
}
